import React from 'react';
import ReactDOM from 'react-dom/client';
import 'assets/style/scss/main.scss';
import 'assets/style/style.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import img404 from 'assets/images/png/img404.png';

window.addEventListener('error', function(e) {
  if (e.target && e.target.tagName && e.target.tagName.toLowerCase() === 'img') {
    // Avoid infinite loop if the 404 image itself doesn't exist
    if (!e.target.src.includes(img404)) {
      e.target.src = img404;
    }
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <App />
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
